
import SwitchBtnEvent from './module/SwitchBtnEvent.js';


(function() {
    window.addEventListener('load', () => {

        setTimeout(() => {//ヘッダーなどの；読み込みが終わってから処理開始
            SwitchBtnEvent();
        }, 0)
    });

})();   